import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask300To399Service {

  constructor() { }
}
